import { useState } from 'react';
import { PaymentUsersFilters } from './payment-users-filters';
import { PaymentUsersFiltersDataProviderProps } from './payment-users-filters.types';
import { AutocompleteOption } from '../../../../../../redesign';
import { useDebounce } from '../../../../../../shared/hooks/use-debounce';
import { useGetWorkerList } from '../../../../../hooks/queryHooks/flexWorkers/use-get-flex-worker-list';
import { useGetFlexWorker } from '../../../../../hooks/queryHooks/flexWorkers/useGetFlexWorker';
import { getWorkerLabel } from '../../utils/get-workers-label';

export const PaymentUsersFiltersDataProvider = (props: PaymentUsersFiltersDataProviderProps) => {
  const [flexWorkerSelectedOption, setFlexWorkerSelectedOption] =
    useState<AutocompleteOption | null>(null);

  const [flexWorkerSearchValue, setFlexWorkerSearchValue] = useState<string>('');
  const debouncedFlexWorkerSearchValue = useDebounce(flexWorkerSearchValue, 300);

  const workersQuery = useGetWorkerList(debouncedFlexWorkerSearchValue);
  const singleWorkerQuery = useGetFlexWorker(props.appliedFilters.worker);

  return (
    <PaymentUsersFilters
      toggleFilters={props.toggleFilters}
      appliedFilters={props.appliedFilters}
      isOpen={props.isOpen}
      handleFiltersChange={props.handleFiltersChange}
      filterData={{
        workers: workersQuery.data || [],
      }}
      selectedWorkerData={
        singleWorkerQuery.data ? getWorkerLabel(singleWorkerQuery.data) : undefined
      }
      flexWorkerOption={flexWorkerSelectedOption}
      setFlexWorkerOption={setFlexWorkerSelectedOption}
      flexWorkerSearch={flexWorkerSearchValue}
      setFlexWorkerSearch={setFlexWorkerSearchValue}
    />
  );
};
